export const STANDART_TYPE = "STANDART";
export const NOT_STANDART_TYPE = "NOT_STANDART";

export const TYPE_LABLES_MAP =  {
    [STANDART_TYPE]: "Стандартне",
    [NOT_STANDART_TYPE]: "Нестандартне"
}

export const PENDING_REVIEW_STATUS = "PENDING_REVIEW";
export const REVIEWED_STATUS = "REVIEWED";
export const IN_PROGRESS_STATUS = "IN_PROGRESS";
export const DOCUMENTATION_PRODUCTION_STATUS = "DOCUMENTATION_PRODUCTION";
export const APPROVED_STATUS = "APPROVED";
export const WAITING_PAYMENT_STATUS = "WAITING_PAYMENT";
export const WAITING_DUCUMENTS_SIGNATURE_STATUS = "WAITING_DUCUMENTS_SIGNATURE";
export const PERMISSION_GRANTED_STATUS = "PERMISSION_GRANTED";
export const INSTALL_COUNTER_STATUS = "INSTALL_COUNTER";
export const COMPLETED_STATUS = "COMPLETED";

export const STATUS_LABELS_MAP = {
    [PENDING_REVIEW_STATUS]: "Очікує на розгляд",
    [REVIEWED_STATUS]: "Переглянута",
    [APPROVED_STATUS]: "Підтверджена",
    [IN_PROGRESS_STATUS]: "Об'єкт в процесі приєднання",
    [DOCUMENTATION_PRODUCTION_STATUS]: "Виготовлення документації",
    [WAITING_PAYMENT_STATUS]: "Очікування оплати",
    [WAITING_DUCUMENTS_SIGNATURE_STATUS]: "Документи передано на підпис",
    [PERMISSION_GRANTED_STATUS]: "Надно дозвіл приєднання",
    [INSTALL_COUNTER_STATUS]: "Встановлення вузла обліку",
    [COMPLETED_STATUS]: "Завершена"
}
